import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { FindAppraiserStore } from '../stores';

export const useFindAppraiserStore = () => useContext<{
  findAppraiserStore: FindAppraiserStore
}>(StoreContext);
